import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  unpinNote: {
    defaultMessage: 'Unpin {noteType}',
    description: 'Unpin note button aria label',
    id: 'jxGpqT',
  },
  pinNote: {
    defaultMessage: 'Pin {noteType}',
    description: 'Pin note button aria label',
    id: '1LPov9',
  },
  unpinTooltip: {
    defaultMessage: 'Unpin',
    description: 'Unpin note button tooltip',
    id: 'M9gZuD',
  },
  pinTooltip: {
    defaultMessage: 'Pin to top and always show',
    description: 'Pin note button tooltip',
    id: 'K51B94',
  },
});
